import { Grid } from '@mui/material';

import { useTableColumnsProducto } from '@/shared';
import { SampleTable } from '@/shared/components/ui';
import { ScrollableDialogProps } from '@/shared/components/ui/Dialogs';
import { IUbicacionProducto } from '@/shared/interfaces/erp/inventario';
import { useMaterialesUtilizadosStore } from '@/store/erp';

export type ViewItemSeriesModalProps = {
  open: boolean;
  setOpen: (open: boolean) => void;
};

const ViewItemSeriesModal: React.FC<ViewItemSeriesModalProps> = ({
  open,
  setOpen,
}) => {
  ///* global state
  const activeItemRow: IUbicacionProducto = useMaterialesUtilizadosStore(
    s => s.activeItemRow
  );
  const setActiveItemRow = useMaterialesUtilizadosStore(
    s => s.setActiveItemRow
  );

  ///* handlers
  const handleClose = () => {
    setOpen(false);
    setActiveItemRow(null);
  };

  ///* table
  const { columnsCargarSeries } = useTableColumnsProducto();

  return (
    <>
      <ScrollableDialogProps
        open={open}
        title={`Series del item: ${activeItemRow?.producto_data?.codigo}`}
        width="69%"
        contentNode={
          <>
            <Grid item xs={12} container spacing={1} mb={3} alignItems="center">
              <Grid
                item
                container
                xs={12}
                alignItems="center"
                justifyContent="space-between"
              >
                <Grid item xs={12}>
                  <SampleTable
                    density="compact"
                    columns={columnsCargarSeries as any}
                    data={
                      useMaterialesUtilizadosStore.getState().activeItemRow
                        ?.series || []
                    }
                    enablePagination={true}
                  />
                </Grid>
              </Grid>
            </Grid>
          </>
        }
        onClose={handleClose}
      />
    </>
  );
};

export default ViewItemSeriesModal;
